import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === 'contained' &&
            ownerState.color === 'primary' && {
              backgroundColor: '#0c68c4',
              color: '#fff',
            }),
        }),
      },
    },
  },
  palette: {
    primary: {
      main: '#0c68c4',
      primaryDark: '#0e2e7f',
      primaryDark1: '#084889',
      primaryBlue: '#3e82c4',
      primaryBlue2: '#2b66b1',
      primaryBlue3: '#2196f3',
      primaryBlue4: '#3F82C4',
      primaryBlue5: '#1772bb',
      primaryBlue6: '#4555a5',
      primaryBlue7: '#4555a5',
      primaryBlue8: '#15ae8a',
      primaryBlue9: '#88b7d5',
      primaryBlue10: '#4f6a77',
      primaryBlue11: '#1565c0',
      primaryBlue12: '#b0e1f8',
      primaryBlue13: '#fbfdff',
      primaryBlueOpacity8: 'rgba(64, 85, 164, 0.8)',
    },
    secondary: { main: '#5a5a5a' },
    gray: {
      grayDD: '#dddddd',
      gray9A: '#9a9a9a',
      gray6A: '#6a6a6a',
      gray7A: '#7a7a7a',
      grayC: '#cccccc',
      gray5a: '#5a5a5a',
      gray3a: '#3a3a3a',
      grayF6: '#F6F6F6',
      grayEF: '#efefef',
      grayA0: '#a0a0a0',
      grayAA: '#aaaaaa',
      gray20: '#333333',
    },
    grayOpacity5: 'rgba(235, 245, 245, 0.5)',
    grayOpacity7: 'rgba(200, 212, 246, 0.7)',
    grayOpacity5a: 'rgba(240, 240, 240, 0.5)',
    grayOpacity5b: 'rgba(200, 200, 200, 0.3)',
    grayOpacity5c: 'rgba(171, 169, 171, 0.5)',
    red: {
      red1: '#f44018',
      red2: '#810909',
      red3: '#f44336',
      red4: '#dc143c',
      red5: 'rgba(220, 20, 60, 0.15)',
      red6: '#A5040C',
    },
    redOpacity8: 'rgba(244, 64, 24, 0.8)',
    paleYellow: '#f8f859',
    white: '#ffffff',
    whiteOpacity7: 'rgba(255, 255, 255, 0.7)',
    whiteOpacity8: 'rgba(255, 255, 255, 0.8)',
    whiteOpacity92: 'rgba(255, 255, 255, 0.92)',
    whiteOpacity95: 'rgba(255, 255, 255, 0.95)',
    whiteOpacity6: 'rgba(255, 255, 255, 0.65)',
    whiteOpacity1: 'rgba(255, 255, 255, 0.1)',
    oceanBluePearl: '#4361ad',
    charcoal: '#444444',
    black: '#000000',
    transparent: 'transparent',
  },
  typography: {
    useNextVariants: true,
  },
});

export default theme;
